// Resolves API + Cognito endpoints at runtime (window.RUNTIME_CONFIG from
// /config.js), with build-time VITE_* fallbacks and localhost defaults, by
// kast-common's createDeploymentConfig. An empty value counts as unset.

import { createDeploymentConfig } from "@jkast90/kast-common/config";

export const deploymentConfig = createDeploymentConfig({
  env: import.meta.env,
  // No per-device overrides.
  storage: null,
  fields: {
    // The dev server proxies /salvagers-api to the deployed API.
    apiUrl: { key: "VITE_SALVAGERS_API_BASE_URL", default: "/salvagers-api" },
    cognitoDomain: "VITE_COGNITO_DOMAIN",
    loginUrl: { key: "VITE_COGNITO_UI_URL", default: "https://login.kast-dev.net" },
    clientId: "VITE_COGNITO_CLIENT_ID",
  },
});

export type DeploymentConfig = ReturnType<typeof deploymentConfig.get>;

export const getDeploymentConfig = deploymentConfig.get;
